import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';

type HospitalOption = { id: string; name: string };

type Props = {
  hospitals: HospitalOption[];
  value: string;
  onChange: (id: string) => void;
  isSuperAdmin?: boolean;
  className?: string;
};

export function ReportHospitalFilter({
  hospitals,
  value,
  onChange,
  isSuperAdmin = false,
  className,
}: Props) {
  const selectValue = isSuperAdmin ? value || 'all' : value || 'all';

  return (
    <div className={`space-y-1 min-w-[220px] ${className ?? ''}`.trim()}>
      <Label className="text-xs text-muted-foreground">Hospital</Label>
      <Select
        value={selectValue}
        onValueChange={(v) => onChange(v === 'all' && isSuperAdmin ? '' : v)}
      >
        <SelectTrigger>
          <SelectValue placeholder="Hospital" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All hospitals (consolidated)</SelectItem>
          {hospitals.map((h) => (
            <SelectItem key={h.id} value={h.id}>
              {h.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
